import { render, staticRenderFns } from "./ChiTiet.vue?vue&type=template&id=c2f140aa&scoped=true&"
import script from "./ChiTiet.vue?vue&type=script&lang=js&"
export * from "./ChiTiet.vue?vue&type=script&lang=js&"
import style0 from "./ChiTiet.vue?vue&type=style&index=0&id=c2f140aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f140aa",
  null
  
)

export default component.exports